import { Router } from '@angular/router';
import { Option } from '@sapphire/result';

import { APP_ROUTES } from '@ps/core-config';
import {
  DASHBOARD_PREVIEW_QUERY_PARAMS,
  MANAGE_SURVEY_TAB_QUERY_PARAM,
  ManageSurveyTabKey,
  SPECIFIC_AUDIENCE_RETURN_QUERY_PARAM,
  SpecificAudienceReturn,
  SURVEY_PREVIEW_TRAFFIC_TAB,
} from '@ps/survey-utils';

export type RouterNavigation = Parameters<Router['navigate']>;

const RETURN_TAB: ManageSurveyTabKey = 'TRAFFIC_CHANNELS';

export const DASHBOARD_NAVIGATION: RouterNavigation = [[APP_ROUTES.DASHBOARD]];

function trafficChannelsNavigation(parentId: number): RouterNavigation {
  return [
    [APP_ROUTES.manageSurvey(parentId)],
    { queryParams: { [MANAGE_SURVEY_TAB_QUERY_PARAM]: RETURN_TAB } },
  ];
}

function dashboardPreviewNavigation(parentId: number): RouterNavigation {
  return [
    [APP_ROUTES.DASHBOARD],
    {
      queryParams: {
        [DASHBOARD_PREVIEW_QUERY_PARAMS.SURVEY_ID]: parentId,
        [DASHBOARD_PREVIEW_QUERY_PARAMS.TAB]: SURVEY_PREVIEW_TRAFFIC_TAB,
      },
    },
  ];
}

// A Specific Audience channel is opened from its parent's Traffic Channels,
// so leaving it returns there: the Manage Survey drawer reopened, or the
// dashboard's Survey Preview on its Traffic tab when it was created there.
// Without a parent to return to, the exit is the dashboard.
export function specificAudienceExitNavigation(
  parentId: Option<number>,
  specificAudienceReturn: SpecificAudienceReturn = 'manage-survey',
): RouterNavigation {
  return parentId.mapOr(DASHBOARD_NAVIGATION, (id) =>
    specificAudienceReturn === 'dashboard'
      ? dashboardPreviewNavigation(id)
      : trafficChannelsNavigation(id),
  );
}

/** The return named on the current Edit Survey URL (`?returnTo=dashboard`). */
export function specificAudienceReturnOf(
  router: Router,
): SpecificAudienceReturn {
  return router
    .parseUrl(router.url)
    .queryParamMap.get(SPECIFIC_AUDIENCE_RETURN_QUERY_PARAM) === 'dashboard'
    ? 'dashboard'
    : 'manage-survey';
}
